/**
 * Global Wishlist System
 * Handles wishlist functionality across header, PDP, and collection pages
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'shopify_wishlist';

  window.WishlistManager = {
    
    getItems: function() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch(e) {
        return [];
      }
    },

    add: function(productId) {
      const items = this.getItems();
      const pid = String(productId);
      if (!items.includes(pid)) {
        items.push(pid);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.updateAllUI();
        this.showToast('Added to Wishlist');
        return true;
      }
      return false;
    },

    remove: function(productId) {
      let items = this.getItems();
      const pid = String(productId);
      items = items.filter(function(id) { return id !== pid; });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      this.updateAllUI();
      this.showToast('Removed from Wishlist');
      return true;
    },

    toggle: function(productId) {
      const pid = String(productId);
      if (this.has(pid)) {
        this.remove(pid);
        return false;
      } else {
        this.add(pid);
        return true;
      }
    },

    has: function(productId) {
      return this.getItems().includes(String(productId));
    },

    count: function() {
      return this.getItems().length;
    },

    updateAllUI: function() {
      const count = this.count();
      const items = this.getItems();
      
      // Update header count bubble
      document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
        el.textContent = count;
      });

      document.querySelectorAll('[data-wishlist-bubble]').forEach(function(el) {
        if (count > 0) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });

      // Update PDP wishlist buttons
      document.querySelectorAll('[data-wishlist-btn]').forEach(function(btn) {
        const pid = String(btn.dataset.productId);
        if (items.includes(pid)) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });

      // Update card wishlist buttons (lux-card style)
      document.querySelectorAll('[data-wish]').forEach(function(btn) {
        const pid = String(btn.dataset.pid);
        if (items.includes(pid)) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      // Dispatch event
      document.dispatchEvent(new CustomEvent('wishlist:updated', { 
        detail: { count: count, items: items } 
      }));
    },

    showToast: function(message) {
      let toast = document.getElementById('wishlist-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'wishlist-toast';
        toast.style.cssText = 'position:fixed;bottom:30px;left:50%;transform:translateX(-50%) translateY(20px);background:#1a1a1a;color:#fff;font-family:inherit;font-size:12px;font-weight:500;letter-spacing:1px;text-transform:uppercase;padding:14px 28px;z-index:99999;opacity:0;transition:all .3s ease;pointer-events:none;border-radius:4px';
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
      
      clearTimeout(toast._timeout);
      toast._timeout = setTimeout(function() {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(20px)';
      }, 2500);
    },

    init: function() {
      const self = this;

      // Update UI on load
      this.updateAllUI();

      // Listen for clicks on PDP wishlist buttons
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-wishlist-btn]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          const pid = btn.dataset.productId;
          if (pid) {
            self.toggle(pid);
          }
        }
      });

      // Listen for clicks on card wishlist buttons
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-wish]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          const pid = btn.dataset.pid;
          if (pid) {
            self.toggle(pid);
          }
        }
      });

      // Cross-tab sync
      window.addEventListener('storage', function(e) {
        if (e.key === STORAGE_KEY) {
          self.updateAllUI();
        }
      });

      // Shopify editor support
      document.addEventListener('shopify:section:load', function() {
        self.updateAllUI();
      });
    }
  };

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      WishlistManager.init();
    });
  } else {
    WishlistManager.init();
  }

})();